import {Injectable} from "@angular/core";

@Injectable()
export class BrowserAgent {

    private isSpecifiedBrowser(browser: string): boolean {
        let navigatorObj = navigator || window.navigator;
        return navigatorObj.userAgent.indexOf(browser) >= 0;
    }

    // IE11 or above Boolean
    private isIE11AndAbove(): boolean {
        return this.isSpecifiedBrowser("Trident") && navigator.userAgent.indexOf("MSIE") < 0;
    }

    // IE10 or below Boolean
    private isIE10AndBelow(): boolean {
        return this.isSpecifiedBrowser("MSIE");
    }

    private isSafari():boolean {
        let navigatorObj = navigator || window.navigator;
        return /^((?!chrome|android).)*safari/i.test(navigatorObj.userAgent);
    }

    public getBrowserName(): string {

        let browser:string;
        console.log("User agent", navigator.userAgent);

        if (this.isSpecifiedBrowser("Edg/")) {
            browser = "Edge";
        } else if (this.isIE11AndAbove() || this.isIE10AndBelow()) {
            browser = "IE";
        } else if (this.isSafari()) {
            browser = "Safari";
        } else if (this.isSpecifiedBrowser("CrOS")) {
                browser = "Chrome OS";
        } else if (this.isSpecifiedBrowser("Chrome/")) {
            browser = "Chrome";
        } else if (this.isSpecifiedBrowser("Gecko/") || this.isSpecifiedBrowser("Firefox/")) {
            browser = "Firefox";
        }  else {
            // we have no clue
            browser = "Unsupported Browser";
        }
        return browser;
    }

    public getFullBrowserInfo(): string {
        let browser: string;

        if (this.isSpecifiedBrowser("Edge/")) {
            browser = navigator.userAgent.match(/Edge[^ ]+/)[0];
        } else if (this.isSafari()) {
            browser = navigator.userAgent.match(/\b[^ ]+$/)[0];
        } else if (this.isSpecifiedBrowser("CrOS")) {
            browser = navigator.userAgent.match(/CrOS [^)]+/)[0];
        } else if (this.isSpecifiedBrowser("Chrome/")) {
            browser = navigator.userAgent.match(/Chrome[^ ]+/)[0];
        } else if (this.isSpecifiedBrowser("Gecko/") || this.isSpecifiedBrowser("Firefox/")) {
            browser = navigator.userAgent.match(/\b[^ ]+$/)[0];
        } else if (this.isSpecifiedBrowser("Safari/")) {
            browser = navigator.userAgent.match(/\b[^ ]+$/)[0];
        } else  {
            // we have no clue
            browser = "Unsupported Browser";
        }
        return browser;
    }

    public getOperatingSystemInfo(): string {
        let operatingSystem: string;

        if (/Macintosh/.test(navigator.userAgent)) {
            operatingSystem = navigator.userAgent.match(/Mac OS X [^;)]+/)[0];
        } else if (/Windows/.test(navigator.userAgent)) {
            operatingSystem = navigator.userAgent.match(/Windows NT\ \d+\.\d+/)[0] || "Windows";
        } else if (/CrOS/.test(navigator.userAgent)) {
            operatingSystem = navigator.userAgent.match(/CrOS [^)]+/)[0];
        } else if (/iPad/.test(navigator.userAgent)) {
            operatingSystem = navigator.userAgent.match(/iPad; [^)]+/)[0];
        } else {
            operatingSystem = "Unsupported OS";
        }
        return operatingSystem.replace(/_/g, ".");
    }
}